import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgDesktop = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 18,
	viewBox: "0 0 20 18",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		opacity: .7,
		children: [/* @__PURE__ */ _jsx("path", { d: "M0-1h20v20H0z" }), /* @__PURE__ */ _jsx("path", {
			fill: "#000",
			fillRule: "nonzero",
			d: "M17.5.667h-15c-.917 0-1.667.75-1.667 1.666v10C.833 13.25 1.583 14 2.5 14h5.833v1.667H6.667v1.666h6.666v-1.666h-1.666V14H17.5c.917 0 1.667-.75 1.667-1.667v-10c0-.916-.75-1.666-1.667-1.666zm0 11.666h-15v-10h15v10z"
		})]
	})
});
export default SvgDesktop;
